<div>

    <table class="dataEntryStatusTbl table filelisttable">
        <thead>
            <tr>
            <th>REQUESTOR</th>
            <th>FILETYPE</th>
            <th>FROM</th>
            <th>TO</th>
            <th>DATE/TIME</th>
            <th>STATUS</th>
            </tr>
        </thead>
        <tbody>
            <tr class="filelisttable" *ngFor="let activity of facilityExportActivity | paginate: config">
                <td>{{activity.requestedBy}}</td>
                <td>{{activity.fileType}}</td>
                <td>{{activity.startYearQuarter}}</td>
                <td>{{activity.endYearQuarter}}</td>
                <td>{{activity.requestDate}}</td>
                <td class="td-status" [ngClass]="getStatusCss(activity.status)"><span
                        class="status circle"></span><span>{{activity.status}}</span></td>
            </tr>
        </tbody>
    </table>

    <div class="text-right paginationtxt">
        <pagination-controls #pagination [id]="config.id" [maxSize]="maxSize" [directionLinks]="directionLinks"
            [autoHide]="autoHide" [responsive]="responsive" [previousLabel]="labels.previousLabel"
            [nextLabel]="labels.nextLabel" [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
            [screenReaderPageLabel]="labels.screenReaderPageLabel"
            [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel" (pageChange)="onPageChange($event)"
            (pageBoundsCorrection)="onPageBoundsCorrection($event)" class="npgo-pagination">
        </pagination-controls>
    </div>

</div>
